var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 65,
    viewBox: "0 0 68 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 65,
    rx: 10,
    fill: "#EB7724"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6842 44.875C47.6842 47.1532 45.7992 49 43.4737 49C41.1482 49 39.2632 47.1532 39.2632 44.875M47.6842 44.875C47.6842 42.5968 45.7992 40.75 43.4737 40.75C41.1482 40.75 39.2632 42.5968 39.2632 44.875M47.6842 44.875H54M39.2632 44.875H37.1579M37.1579 44.875H26.6316M37.1579 44.875V22.6C37.1579 20.2898 37.1579 19.1347 36.6989 18.2523C36.2954 17.4761 35.6512 16.8451 34.8589 16.4496C33.9583 16 32.7792 16 30.4211 16H20.7368C18.3787 16 17.1997 16 16.299 16.4496C15.5067 16.8451 14.8626 17.4761 14.4589 18.2523C14 19.1347 14 20.2898 14 22.6V40.75C14 43.0282 15.8851 44.875 18.2105 44.875M37.1579 44.875V24.25H45.5789L51.8947 32.5M26.6316 44.875C26.6316 47.1532 24.7465 49 22.4211 49C20.0956 49 18.2105 47.1532 18.2105 44.875M26.6316 44.875C26.6316 42.5968 24.7465 40.75 22.4211 40.75C20.0956 40.75 18.2105 42.5968 18.2105 44.875M51.8947 32.5V44.875M51.8947 32.5H37.1579",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportIcon);
export default __webpack_public_path__ + "static/media/transport-icon.2fd45fee509b673e467a1782e0d1cf18.svg";
export { ForwardRef as ReactComponent };